/** @jsx h */
import { h } from 'preact'

import { AboutStickyHeader } from '../StickyHeader'
import StaticCapsuleList from '../../StaticCapsuleList'
import FooterCTA from '../../FooterCTA'
import Climate from '../../../../../assets/images/svgs/icon-climate.svg'
import Waste from '../../../../../assets/images/svgs/icon-waste.svg'
import Nature from '../../../../../assets/images/svgs/icon-nature.svg'
import Workers from '../../../../../assets/images/svgs/icon-workers.svg'
import Communities from '../../../../../assets/images/svgs/icon-communities.svg'
import ArrowIcon from '../../../../../assets/images/svgs/icon-arrow-right-2.svg'
import InstagramIcon from '../../../../../assets/images/svgs/icon-instagram-small.svg'
import t from '../../../../utils/translate'

const AboutCard = props => {
  return (
    <article class={`
      AboutCard
      AboutCard--hasBgImg
      ${props.revealed ? 'AboutCard--revealed' : ''}
      ${props.inJourney ? 'AboutCard--inJourney' : ''}
    `}
    >
      <AboutStickyHeader
        title='PROVENANCE'
        type='About'
      />
      <div class='ModalCard-content'>
        <div class='stack-5' dangerouslySetInnerHTML={{ __html: props.content }} />

        <Climate class='ThemeIcon' />
        <Waste class='ThemeIcon' />
        <Nature class='ThemeIcon' />
        <Workers class='ThemeIcon' />
        <Communities class='ThemeIcon' />

        <StaticCapsuleList />
      </div>

      <FooterCTA href='https://www.instagram.com/provenancehq/'>
        <InstagramIcon />
        {t('js.footer_cta')}
        <ArrowIcon />
      </FooterCTA>
    </article>
  )
}

AboutCard.defaultProps = {

}

export default AboutCard
